const messages = {
  'ACCOUNT_SUM': 'Tili',
  'ADD_MEMEBER_FAILED': 'Lisäys epäonnistui. Syy: {Message}',
  'ADD_ORIGINATOR_FAILED': 'Aloitteentekijän lisäys epäonnistui. Syy : Aloitteentekijä on jo lisätty aiemmin.',
  'APPLICATION MANUAL': 'JÄRJESTELMÄN KÄYTTÖOHJE',
  'APP_BANNER_DESC': 'Kehitysehdotustoiminnan avulla kerätään ideoita henkilökunnalta ja saadaan koko henkilöstö mukaan yrityksen toiminnan kehittämiseen. Tällä työkalulla tehdään ja hallinnoidaan kehitysehdotustoimintaan kuuluvia jatkuvan parantamisen ehdotuksia ja aloitteita.',
  'APP_NAME': 'Jatkuvan parantamisen hallintajärjestelmään',
  'ASK_EXPERT_OPINIONS': 'Sähköposti lähetetty!',
  'ATTACH_FILES_HELP': 'Liitä tiedosto(t)',
  'Account': 'Tili',
  'Active': 'Aktiivinen',
  'Add': 'Lisää',
  'Add new initiative type': 'Lisää uusi aloitetyyppi',
  'Admin': 'Ylläpitäjä',
  'All': 'Kaikki',
  'Amount': 'Määrä',
  'Approve': 'Hyväksy',
  'Ask expert opinion': 'Pyydä asiantuntijan lausunto',
  'Attach files': 'Liitä tiedosto(t)',
  'Attached files': 'Liitetyt tiedostot',
  'Author': 'Tekijä',
  'BROWSE': 'SELAA',
  'Browse CI-Proposals': 'Selaa JP-ehdotuksia',
  'Browse Initiatives': 'Selaa aloitteita',
  'Browse old Initiatives and CI-Proposals': 'Selaa vanhoja aloitteita ja JP-ehdotuksia',
  'CI Proposal created': 'JP-ehdotus luotu',
  'CI-Proposal': 'JP-Ehdotus',
  'CIP': 'kehitysideaa',
  'CIP Group': 'JP-Ryhmä',
  'CIP Id': 'JP #',
  'CIP Groups': 'JP-Ryhmät',
  'CIP-GROUPS': 'JP-RYHMÄT',
  'CIP-Group': 'JP-Ryhmä',
  'CIP.CI_GROUP.HELP': 'Valitse oma JP-ryhmäsi.',
  'CIP.NAME.HELP': 'Syötä kenttään nimesi. Annettuasi osan nimestäsi, valitse ehdotetuista vaihtoehdoista oikea. Mikäli nimeäsi ei löydy, ota yhteyttä Juha Jaakkola juha.jaakkola@wartsila.com.',
  'CIP.PROPOSAL.HELP': 'Kuvaa tähän ehdotuksesi.',
  'CIP.TITLE.HELP': 'Anna ehdotusta kuvaava otsikko.',
  'CIP_DESC': 'Jatkuva parantaminen on paikallista toiminnan kehittämistä ryhmässä. JP:n avulla kehitetään mm. oman työympäristön siisteyteen, työtapoihin, työturvallisuuteen ja viihtyvyyteen liittyviä asioita.',
  'CIP_FULL': 'JP-Ehdotukset',
  'CONTINUOUS IMPROVEMENT': 'KEHITYSEHDOTUSTOIMINTA',
  'CREATE CONTINUOUS IMPROVEMENT': 'TEE JP-EHDOTUS',
  'CREATE INITIATIVE': 'TEE ALOITE',
  'CURRENT_SITUATION': 'Nykytilanne',
  'CURRENT_SITUATION_HELP': 'Kuvaa nykytilanne',
  'Coach name': 'Coach',
  'Comment': 'Kommentti',
  'Cost center': 'Kustannuspaikka',
  'Created': 'Luotu',
  'Created by': 'Tekijä',
  'Created date': 'Luonti pvm',
  'DEPOSIT_WITHDRAW_AMOUNT': 'Lisättävä/poistettava summa',
  'Department': 'Osasto',
  'Deposit': 'Lisaa summa',
  'Deposit or withdraw money': 'Lisää tai poista summa JP-ryhmältä',
  'Description': 'Kuvaus',
  'Display Name': 'Näytä nimi',
  'Domain': 'Domain',
  'Email': 'Sähköposti',
  'Error': 'Virhe',
  'Euro': 'Euro',
  'Euros': 'Euroa',
  'FOCUS Users': 'FOCUS Käyttäjät',
  'Failed': 'Epäonnistui',
  'Filter': 'Suodatus',
  'GOOD TO KNOW': 'HYVÄ TIETÄÄ',
  'Group members': 'Ryhmän jäsenet',
  'Group transactions': 'Ryhmän transaktiot',
  'HOME': 'ETUSIVU',
  'Hide reward calculator': 'Piilota palkkiolaskin',
  'How to use this application': 'Kuinka käytät tätä järjestelmää',
  'IMPROVEMENT_PROPOSAL': 'Parannusehdotus',
  'IMPROVEMENT_PROPOSAL_HELP': 'Kuvaile parannusehdotuksesi.',
  'INITIATIVE': 'Aloite',
  'INITIATIVE_DESC': 'Aloite on henkilökohtainen kehitysehdotus, joka sisältää ratkaisun josta voidaan laskea taloudellinen hyöty yritykselle.',
  'INITIATIVE_NAME': 'Aloitteen nimi',
  'INITIATIVE_NAME_HELP': 'Anna tähän kuvaava otsikko aloitteellesi.',
  'INITIATIVE_TYPE_HELP': 'Valitse aloitteen tyyppi.',
  'Id': 'Id',
  'Idea originator': 'Tekijä',
  'Ideas': 'Ideaa',
  'In review': 'Esikatselussa',
  'Initiative Types': 'Aloitetyypit',
  'Initiative created': 'Aloite luotu',
  'Initiative reassigned to:': 'Aloite uudelleenosoitettu:',
  'Initiative type with same title exists.': 'Samanniminen aloite tyyppi on jo olemassa.',
  'Initiatives': 'Aloitteet',
  'Is Active': 'Aktiivinen',
  'Is Admin': 'Pääkäyttäjä',
  'Journals': 'Tapahtumat',
  'LOCAL IDEAS': 'SELAA IDEOITA',
  'LOCALE_en': 'ENGLISH-EN',
  'LOCALE_en-EN': 'ENGLISH-EN',
  'LOCALE_en-US': 'ENGLISH-EN',
  'LOCALE_fi': 'SUOMI-FI',
  'LOCALE_fi-FI': 'SUOMI-FI',
  'LOCALE_sv': 'SVENSKA-SV',
  'LOCALE_sv-SE': 'SVENSKA-SV',
  'Last 30 Days': 'Edelliset 30 päivää',
  'Last 7 Days': 'Edelliset 7 päivää',
  'Last Month': 'Edellinen kuukausi',
  'MANAGE IDEAS': 'HALLITSE IDEOITA',
  'Make decision': 'Tee päätös',
  'Manager': 'Esimies',
  'Modified': 'Muokattu',
  'NAME_HELP': 'Syötä kenttään nimesi. Annettuasi osan nimestäsi, valitse ehdotetuista vaihtoehdoista oikea. Mikäli nimeäsi ei löydy, ota yhteyttä Juha Jaakkola juha.jaakkola@wartsila.com. Syötä tietosi vaikka jättäisitkin ilmoituksen nimettömänä.',
  'NEW_CI-GROUP-CREATED': 'Uusi JP-ryhmä luotu :#{Id}',
  'NEW_INITIATIVE_TYPE_ADDED': 'Uusi aloitteentyyppi lisätty.',
  'NO_DATA': 'Ei tietoja saatavilla...',
  'Name': 'Nimi',
  'New': 'Uusi',
  'New initiative type is added': 'Uusi aloitetyyppi lisätty.',
  'Next': 'Seuraava',
  'Not Active': 'Ei aktiivinen',
  'Not admin': 'Ei pääkäyttäjä',
  'Open': 'Avoinna',
  'Paid': 'Maksettu',
  'Pending': 'Odottaa',
  'Previous': 'Edellinen',
  'Print': 'Tulosta',
  'Proposal': 'Ehdotus',
  'REASSIGN_OK': 'Aloitteen uudelleen ohjaus onnistunut !',
  'REPORT_ANONYMOUS': 'Haluan jättää ehdotuksen nimettömänä',
  'REWARD.EFFECTIVENESS': 'Kustannussäästöt tehokkuus (Läpimenoaika, kiertonopeus)',
  'REWARD.EFFECTIVENESS_COL1': 'Hinnaltaan edullisempi ratkaisu. Läpimenoajan nopeutuminen kyseisessä työvaiheessa. Esim. työvaiheen kehittäminen tai säästö n. 500 - 1000 euroa vuodessa.',
  'REWARD.EFFECTIVENESS_COL2': 'Läpimenoajan nopeutuminen tai turhan työvaiheen poistaminen Esim. Koneistuksen tai asennuksen kehittäminen tai säästö n. 1000 - 5 000.',
  'REWARD.EFFECTIVENESS_COL3': 'Lyhentää lopputuotteen tai osatoimitusten läpimenoaikaa huomattavasti tai säästöt n. 5 000 - 50 000 euroa vuodessa.',
  'REWARD.EFFECTIVENESS_COL4': 'Poikkeuksellisen merkittävät säästöt läpi tuotteen elinkaaren tai merkittävät kustannussäästöt esim. Huoltomenetelmissä. Tai säästöt > 50 000 euroa vuodessa.',
  'REWARD.ENVIRONMENT': 'Ympäristö',
  'REWARD.ENVIRONMENT_COL1': 'Materiaalin tai energian käyttö vähenee. / Tavanomaisen jätteen määrä vähenee.',
  'REWARD.ENVIRONMENT_COL2': 'Vähentää materiaalin tai energian käyttöä merkittävästi osastolla / Vähentää vaarallisen jätteen (esim. öljyiset jätteet) määrää / Vähentää merkittävästi jätteiden määrää.',
  'REWARD.ENVIRONMENT_COL3': 'Pienentää merkittävästi vakavaa ympäristöriskiä. Vähentää merkittävästi laitoksen päästöjä.',
  'REWARD.ENVIRONMENT_COL4': 'Parannusehdotus, jota voidaan hyödyntää useassa Wärtsilän yksikössä vähentämään päästöjä, energian- tai materiaalien käyttöä (ml.kemikaalit), tai vähentämään jätteiden määrää.',
  'REWARD.GLOBAL': 'Globaali',
  'REWARD.OWN_BUSINESS_UNIT': 'Liiketoimintayksikkö',
  'REWARD.OWN_DEPARTMENT': 'Oma osasto',
  'REWARD.OWN_STATION': 'Oma työpiste',
  'REWARD.QUALITY': 'Laatu',
  'REWARD.QUALITY_COL1': 'Pieni laatuparannus omalla työpisteellä. Esim. Epäselvien työohjeiden parantaminen.',
  'REWARD.QUALITY_COL2': 'Laatuparannus omalla osastolla. Esim. työvaiheen kehittäminen. Vähentää tai ennaltaehkäisee laatuongelmia omalla osastolla.',
  'REWARD.QUALITY_COL3': 'Vähentää tai ennaltaehkäisee laatuongelmia liiketoimintayksikössä / innovaatio joka merkittävästi parantaa tuotteen / prosessin laatua.',
  'REWARD.QUALITY_COL4': 'Pitkään tuotetta vaivannut kriittisen laatuongelman ratkaisu Vähentää tai ennaltaehkäisee laatuongelmia maailmanlaajuisesti / Innovaatio, joka on merkittävä.',
  'REWARD.SAFETY': 'Työturvallisuus',
  'REWARD.SAFETY_COL1': 'Pieni työturvallisuusparannus omalla työpisteellä työkaluun, työmenetelmään tai työympäristöön.',
  'REWARD.SAFETY_COL2': 'Turvallisuusparannus joka vähentää kemikaali- tai muuta altistusta, tai parantaa merkittävästi ergonomiaa / Turvallisuusparannus joka vähentää tapaturmavaaraa.',
  'REWARD.SAFETY_COL3': 'Vähentää tai ennaltaehkäisee työtapaturmia tai sairaspoissaoloja Iiiketoimintayksikössä. Parantaa työturvallisuutta tai työterveyttä merkittävästi.',
  'REWARD.SAFETY_COL4': 'Vähentää työtapaturmia tai sairaspoissaoloja useassa Wärtsilän yksikössä / Innovaatio, joka maailmanlaajuisesti lisää merkittävästi työturvallisuutta tai työterveyttä.',
  'REWARD_CONSULTED': 'Olen konsultoinut aloitteen tekijää.',
  'REWARD_SENT': 'Olen lähettänyt palkitsemiskaavakkeen SD Worx:iin ja aloitekomitean sihteerille.',
  'Ready': 'Valmis',
  'Reassign': 'Uudelleen ohjaus',
  'Reassign to different person': 'Osoita toiselle henkilölle',
  'Rejected': 'Hylätty',
  'Remove': 'Poista',
  'Request for expert opinion:': 'Pyydetty asiantuntijan mielipidettä:',
  'Responsible person': 'Vastuuhenkilö',
  'Reward sum': 'Palkkio',
  'Rewarded with amount:': 'Palkittu summalla:',
  'Rewarding template': 'Palkitsemismalli',
  'Rules': 'Säännöt',
  'SAP Number': 'SAP-numero',
  'SAVE_CI-GROUP-OK': 'JP-ryhmä tallennettu.',
  'SAVE_INITIATIVE_FAILED': 'Aloitteen tallennus epäonnistui !',
  'SAVE_INITIATIVE_OK': 'Aloite tallennettu !',
  'SAVE_INITIATIVE_TYPE_OK': 'Aloitteen tyyppi tallennettu onnistuneesti.',
  'SAVE_REWARD_OK': 'Palkkio tallennettu onnistuneesti.',
  'SEARCH': 'ETSIÄ',
  'SEE_YOU_AGAIN': 'Uloskirjautuminen onnistui. Kiitos ja näkemiin!',
  'SEND_TO_COMMITTEE': 'Haluan aloitteen käsiteltäväksi uudessa järjestelmässä',
  'Save': 'Tallenna',
  'Save and send': 'Tallenna ja lähetä',
  'Select': 'Valitse',
  'Select an initiative type here': 'Valitse aloitteen tyyppi.',
  'Show reward calculator': 'Näytä palkkiolaskin',
  'Sign in again': 'Kirjaudu uudelleen',
  'State': 'Tila',
  'Status': 'Tila',
  'Success': 'Onnistui',
  'TASK_WARNING': 'Sinulla on {value} uutta tehtävää.',
  'INITIATIVE_WARNING': '{value} uutta aloitetta',
  'IDEAS_WARNING': '{value} uutta J-P ideaa',
  'OPINION_WARNING': '{value} avointa lausuntopyyntöä',
  'TRANSACTION_FAIL': 'Transaktio epäonnistui. Syy: {Message}',
  'TRANSACTION_OK': 'Transaktio suoritettu onnistuneesti !',
  'Thank you': 'Kiitos!',
  'This Month': 'Tämä kuukausi',
  'This Year': 'Tänävuonna',
  'Title': 'Otsikko',
  'Title_FI': 'Otsikko FI',
  'Title_EN': 'Otsikko EN',
  'Title_SV': 'Otsikko SV',
  'Type': 'Tyyppi',
  'USERS': 'KÄYTTÄJÄT',
  'USER_ALREADY_IN_GROUP': 'Käyttäjä on jo ryhmässä.',
  'User': 'User',
  'User with same account exists.': 'Käyttäjätili on jo olemassa.',
  'WELCOME': 'Tervetuloa',
  'Waiting For Commitee': 'Odottaa toimikunnan päätöstä',
  'Waiting To Be Implemented': 'Odottaa toteutusta',
  'Withdraw': 'Poista summa',
  'YEAR': 'vuonna',
  'You can browse existing CI-Proposals': 'Voit selata olemassaolevia JP-ehdotuksia',
  'You can browse existing Initiatives': 'Voit selata olemassaolevia aloitteita',
  'initiative(s)': 'aloitetta',
  'Expert Opinion': 'Asiantuntijan lausunto',
  'Clear': 'Tyhjennä',
  'Rewarding form': 'Palkitseminen',
  'Add comment or opinion': 'Lisää kommentti tai mielipide',
  'Email sent': 'Sähköposti lähetetty',
  'No name selected': 'Nimi puuttuu',
  'Please select a name and click': 'Valitse nimi ja paina',
  'Save Draft': 'Tallenna luonnos',
  'To continue, please select a name and click': 'Jatkaaksesi, valitse nimi ja paina',
  'Toggle table filter': 'Näytä/piilota suodatus',
  'Send emails': 'Lähetä sähköposti',
  'Country': 'Maa',
  'MANUAL_URL': 'https://fiidm01.wnsd.com/kronodoc/1502/GetLatest/9148861/FOCUS%202.0%20FI%20k%C3%A4ytt%C3%B6ohje.pptx',
  'FOCUS_INDICATORS': 'Focus mittarit',
  'LINKS_HEADER': 'LINKIT'
};

export default messages;



// WEBPACK FOOTER //
// ./locales/fi.js